import {useTheme} from '../../../shared/theme';
import {useStyles} from '../../../shared/hooks/styles';
import {StyleSheet, View as RNView} from 'react-native';
import {DeviceSize} from '../../../shared/theme/helpers';
import {Text} from '../../../shared/components/text';
import {Button} from '../../../shared/components/button';
import {OrDelimiter} from '../../../shared/components/orDelimiter';
import React, {useState} from 'react';
import {WebView, WebViewProps} from 'react-native-webview';
import {WebViewErrorEvent} from 'react-native-webview/lib/WebViewTypes';
import {useCustomBackhandler} from '../../../shared/hooks/useCustomBackhandler';
import {Platform} from 'react-native';
import {Preloader} from '../../../shared/components/preloader';
import {ShouldStartLoadRequest} from 'react-native-webview/lib/WebViewTypes';

export interface ViewProps {
  link: string | null;
  isNotAccept: boolean;
  isProcessed: boolean;
  openHowToPage: () => void;
  goBack: () => void;
  onNavigationStateChange: WebViewProps['onNavigationStateChange'];
  onShouldStartLoadWithRequest?: (request: ShouldStartLoadRequest) => boolean;
}

export default ({
  link,
  goBack,
  openHowToPage,
  onNavigationStateChange,
  onShouldStartLoadWithRequest,
  isNotAccept,
  isProcessed,
}: ViewProps) => {
  const theme = useTheme();
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const isOldAndroid = Platform.OS === 'android' && typeof Platform.Version === 'number' && Platform.Version < 29;

  const styles = useStyles(({mediaOnly}) => ({
    root: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    webView: {
      borderRadius: 5,
    },
    helperText: {
      color: theme.helpText.color,
      marginTop: 18,
      marginBottom: 24,
      marginHorizontal: 44,
      textAlign: 'center',
    },
    buttonWrapper: {
      marginTop: 'auto',
      paddingHorizontal: 30,
    },
    button: StyleSheet.flatten([
      {
        alignSelf: 'center',
        marginTop: 'auto',
        marginBottom: 0,
      },
      mediaOnly(DeviceSize.desktop, {width: 300}, {width: '100%'}),
    ]),
  }));

  useCustomBackhandler();

  if (isNotAccept) {
    return (
      <RNView>
        <Text type='caption' style={styles.helperText}>
          Посмотрите инструкцию по подтверждению записи на Госуслугах
        </Text>
        <RNView style={styles.buttonWrapper}>
          <Button
            id='login-enter-next'
            type='secondary'
            style={styles.button}
            onPress={openHowToPage}
            text='Как подтвердить запись?'
          />
          <OrDelimiter />
          <Button
            id='login-width-esia'
            type='secondary'
            style={styles.button}
            onPress={goBack}
            text='Войти другим способом'
          />
        </RNView>
      </RNView>
    );
  }

  // https://developer.apple.com/documentation/foundation/1508628-url_loading_system_error_codes
  // https://developer.android.com/reference/android/webkit/WebViewClient#constants_1
  // Our error for bad Esia opening in case of the app's user being outside RU is ERROR_TIMEOUT (for Android OS that is code `-8`; same for iOS is `-1001`)
  const isTimeOut = (webViewErrorEvent: WebViewErrorEvent) =>
    webViewErrorEvent.nativeEvent.code === -8 || webViewErrorEvent.nativeEvent.code === -1001;

  const handleError = (webViewErrorEvent: WebViewErrorEvent) => {
    if (isProcessed) return;

    setIsError(true);
    if (isTimeOut(webViewErrorEvent)) {
      setErrorMessage('Недоступно в вашем регионе');
      return;
    }
    setErrorMessage('Сервис временно недоступен. Попробуйте позже или обратитесь в тех. поддержку');
  };

  return (
    <RNView style={styles.root}>
      <WebView
        scalesPageToFit
        startInLoadingState
        androidHardwareAccelerationDisabled
        androidLayerType={isOldAndroid ? 'software' : undefined}
        thirdPartyCookiesEnabled
        cacheEnabled={false}
        mixedContentMode='compatibility'
        source={{uri: link ?? ''}}
        containerStyle={styles.webView}
        onNavigationStateChange={onNavigationStateChange}
        onShouldStartLoadWithRequest={onShouldStartLoadWithRequest}
        renderLoading={() => <Preloader type='main' />}
        isLoading={isProcessed || !link}
        isError={isError}
        onError={(e) => handleError(e)}
        renderError={() => (
          <Text type='h5' style={{textAlign: 'center', textAlignVertical: 'center'}}>
            {errorMessage}
          </Text>
        )}
      />
    </RNView>
  );
};
